import { ENV } from '@/config/env/env.read';

const fallback = typeof window === 'undefined' ? 'http://localhost' : window.location.origin;

const api = new URL(ENV.apiUrl || fallback);

const base = `${api.origin}${api.pathname.replace(/\/+$/, '')}`;

export const BEAUTH_API_ORIGINS: readonly string[] = [api.origin];

export const BEAUTH_FLOW_BASE_URL = `${base}/auth`;

export const BEAUTH_REFRESH_URL = `${base}/auth/session/refresh`;

export const BEAUTH_LOGOUT_URL = `${base}/auth/session/logout`;

export const BEAUTH_SOCKET_EXPIRED_EVENT = 'auth:expired';

export const BEAUTH_PASSWORD_MIN = 12;

export const BEAUTH_PASSWORD_MAX = 256;
